import { render } from "./Watch.vue?vue&type=template&id=73872abd&scoped=true"
import script from "./Watch.vue?vue&type=script&lang=js"
export * from "./Watch.vue?vue&type=script&lang=js"

import "./Watch.vue?vue&type=style&index=0&id=73872abd&scoped=true&lang=css"

import exportComponent from "C:\\Users\\Oliver Traber\\Nextcloud\\VSCode Projects\\video-platform\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-73872abd"]])

export default __exports__